const countryNameCodes = {
    Deutschland: '276',
    Afghanistan: '004',
    Ägypten: '818',
    Albanien: '008',
    Algerien: '012',
    'Amerikanisch Samoa': '016',
    'Amerikanische Jungferninseln': '850',
    Andorra: '020',
    Angola: '024',
    Anguilla: '660',
    Antarktis: '010',
    'Antigua und Barbuda': '028',
    Äquartorialguinea: '226',
    Argentinien: '032',
    Armenien: '051',
    Aruba: '533',
    Aserbaidschan: '031',
    Äthiopien: '231',
    Australien: '036',
    Bahamas: '044',
    Bahrain: '048',
    Bangladesch: '050',
    Barbados: '052',
    'Belarus (Weissrussland)': '112',
    Belgien: '056',
    Belize: '084',
    Benin: '204',
    Bermuda: '060',
    Bhutan: '064',
    Bolivien: '068',
    'Bosnien Herzegowina': '070',
    Botswana: '072',
    Brasilien: '076',
    'Britische Jungferninseln': '092',
    'Brunei Darussalam': '096',
    Bulgarien: '100',
    'Burkina Faso': '854',
    Burundi: '108',
    Chile: '152',
    China: '156',
    Cookinseln: '184',
    'Costa Rica': '188',
    Dänemark: '208',
    'Diego Garcia': '086',
    Dschibuti: '262',
    Dominica: '212',
    'Dominikanische Republik': '214',
    Ecuador: '218',
    'El Salvador': '222',
    Elfenbeinküste: '384',
    Eritrea: '232',
    Estland: '233',
    'Falkland Inseln': '238',
    Färöer: '234',
    Fidschi: '242',
    Finnland: '246',
    Frankreich: '250',
    'Französisch Guyana': '254',
    'Französisch Polynesien': '258',
    Gabun: '266',
    Gambia: '270',
    Georgien: '268',
    Ghana: '288',
    Gibraltar: '292',
    Grenada: '308',
    Griechenland: '300',
    Grönland: '304',
    Großbritannien: '826',
    Guadeloupe: '312',
    Guam: '316',
    Guatemala: '320',
    Guinea: '324',
    'Guinea-Bissau': '624',
    Guyana: '328',
    Haiti: '332',
    Honduras: '340',
    Hongkong: '344',
    Indien: '356',
    Indonesien: '360',
    Irak: '368',
    Iran: '364',
    Irland: '372',
    Island: '352',
    Israel: '376',
    Italien: '380',
    Jamaika: '388',
    Japan: '392',
    Jemen: '887',
    Jordanien: '400',
    Kaimaninseln: '136',
    Kambodscha: '116',
    Kamerun: '120',
    Kanada: '124',
    'Kap Verde': '132',
    Kasachstan: '398',
    Katar: '634',
    Kenia: '404',
    Kirgisistan: '417',
    Kiribati: '296',
    'Kokos Inseln': '166',
    Kolumbien: '170',
    Komoren: '174',
    'Kongo, Demokratische Republik': '180',
    'Kongo, Republik': '178',
    'Korea (Demokratische Republik)': '408',
    'Korea (Republik)': '410',
    Kosovo: '983',
    Kroatien: '191',
    Kuba: '192',
    Kuwait: '414',
    Laos: '418',
    Lesotho: '426',
    Lettland: '428',
    Libanon: '422',
    Liberia: '430',
    Libyen: '434',
    Liechtenstein: '438',
    Litauen: '440',
    Luxemburg: '442',
    Macau: '446',
    Madagaskar: '450',
    Malawi: '454',
    Malaysia: '458',
    Malediven: '462',
    Mali: '466',
    Malta: '470',
    Marokko: '504',
    Marschallinseln: '584',
    Martinique: '474',
    Mauretanien: '478',
    Mauritius: '480',
    Mayotte: '175',
    Mexiko: '484',
    Micronesia: '583',
    Moldawien: '498',
    Monaco: '492',
    Mongolei: '496',
    Montenegro: '499',
    Montserrat: '500',
    Mosambik: '508',
    Myanmar: '104',
    Namibia: '516',
    Nauru: '520',
    Nepal: '524',
    Neukaledonien: '540',
    Neuseeland: '554',
    Nicaragua: '558',
    Niederlande: '528',
    'Niederländische Antillen': '530',
    Niger: '562',
    Nigeria: '566',
    'Niue (Neuseeland)': '570',
    'Noerdliche Marianen': '580',
    Nordmazedonien: '807',
    Norfolkinsel: '574',
    Norwegen: '578',
    Oman: '512',
    Österreich: '040',
    Pakistan: '586',
    Palästina: '275',
    Palau: '585',
    Panama: '591',
    'Papua-Neuguinea': '598',
    Paraguay: '600',
    Peru: '604',
    Philippinen: '608',
    'Pitcairn-Inseln': '612',
    Polen: '616',
    Portugal: '620',
    'Puerto Rico': '630',
    'Reunion (Frankreich)': '638',
    Ruanda: '646',
    Rumänien: '642',
    'Russische Föderation': '643',
    'Sahara (Westsaharah)': '732',
    'Saint Helena': '654',
    'Saint Kitts und Nevis': '659',
    'Saint Lucia': '662',
    'Saint Pierre and Miguelon': '666',
    'Saint Vincent u.Grenadinen': '670',
    'Saint-Martin': '663',
    Salomonen: '090',
    'Samoa (Westsamoa)': '882',
    'San Marino': '674',
    'Sao Tome and Principe': '678',
    'Saudi-Arabien': '682',
    Schweden: '752',
    Schweiz: '756',
    Senegal: '686',
    Serbien: '688',
    Seychellen: '690',
    'Sierra Leone': '694',
    Simbabwe: '716',
    Singapur: '702',
    'Sint Maarten': '534',
    Slowakei: '703',
    Slowenien: '705',
    Somalia: '706',
    Spanien: '724',
    'Sri Lanka': '144',
    Südafrika: '710',
    Sudan: '729',
    Südsudan: '728',
    Suriname: '740',
    'Svalbard und Jan Mayen': '744',
    Swasiland: '748',
    Syrien: '760',
    Tadschikistan: '762',
    Taiwan: '158',
    Tansania: '834',
    Thailand: '764',
    'Timor-Leste': '626',
    Togo: '768',
    Tokelau: '772',
    Tonga: '776',
    'Trinidad und Tobago': '780',
    Tschad: '148',
    Tschechien: '203',
    Tunesien: '788',
    Türkei: '792',
    Turkmenistan: '795',
    'Turks und Caicos Inseln': '796',
    Tuvalu: '798',
    Uganda: '800',
    Ukraine: '804',
    Ungarn: '348',
    Uruguay: '858',
    Usbekistan: '860',
    Vanuatu: '548',
    Vatikanstadt: '336',
    Venezuela: '862',
    'Vereinigte Arabische Emirate': '784',
    'Vereinigte Staaten (USA)': '840',
    Vietnam: '704',
    'Wallis und Futuna': '876',
    'Weinachtsinseln (Australien)': '162',
    Zambia: '894',
    'Zentralafrikanische Republik': '140',
    Zypern: '196',
    Staatenlos: '999',
};

export default countryNameCodes;
